<template>
  <div class="conteudoInterno" id="arrecadacao">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Arrecadação</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcGreenBack"></span>
        </div>
        <div class="col66 spaceBetween top32">
          <div class="col49sub">
            <p>
              Os dados apresentados nesta seção correspondem à soma das arrecadações referentes aos direitos de execução pública no Brasil, realizadas pelo Ecad — o órgão responsável pela cobrança e distribuição — em nome das sete entidades de gestão coletiva do país, incluindo a UBC.
            </p>
            <p>
              Atualmente, o sistema vigente concede licenças que abrangem tanto os direitos autorais quanto os direitos conexos da maioria — mas não de todos — os usuários. Existem algumas exceções no que diz respeito às licenças de direitos conexos, como é o caso dos shows ao vivo (onde não há gravações para servir de base à distribuição) e de diversos serviços de streaming de música e vídeo (cujos licenciamentos são feitos diretamente pelas gravadoras).
            </p>
          </div>
          <div class="col49sub">
            <p>
              Vale destacar também que os valores apresentados nesta seção não englobam os direitos fonomecânicos, que ainda não contam com uma estrutura unificada de gestão coletiva no Brasil.
            </p>
            <p>
              No entanto, a parte final do relatório traz informações específicas da UBC, incluindo dados sobre os direitos fonomecânicos que são administrados por nós, embora esses números reflitam apenas um panorama parcial do mercado. 
            </p>
          </div>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            <span class="ubcGreen sanukBlack">R$ 1.830.908.837</span> foram o
            montante arrecadado em 2024, o que representa um
            <span class="ubcGreen sanukBlack">aumento de 12%</span> em relação
            ao ano anterior.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h3>Participação na arrecadação por tipo de uso</h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <PieChart1 v-if="isView" />
            </div>
          </div>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h3>Crescimento por tipo de uso</h3>
          <span style="font-size: 12px; margin-top: 40px; margin-bottom: -30px; display: block;">BRL</span>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
            <LineChart1A />
            </div>
          </div>
        </div>
      </section>
      <!-- <section class="sectionRow top120">
        <div class="col49">
          <h3>Participação na arrecadação por tipo de uso</h3>
          <div class="top20">
            <PieChart1 />
          </div>
        </div>
        <div class="col49">
          <h3>Crescimento por tipo de uso</h3>
          <div class="graphContainer">
            <div class="graph">

            <LineChart1A />
            </div>
          </div>
        </div>
      </section> -->
      <section class="sectionRow top80">
        <div class="col40ponto4 ubcGreenBack">
          <!-- imagem -->
        </div>
        <div class="col49 spaceBetween">
          <div class="col100">
            <h4 class="h4Destaque ubcGreen sanukBlack">Destaques</h4>
          </div>
          <div class="col100 spaceBetween top50">
            <div class="col49sub">
              <div class="blockBigNumbers">
                <div>
                  <h6>Crescimento de</h6>
                  <h5 class="ubcGreen sanukBlack">18,2%</h5>
                  <h6>
                    em <span class="sanukBold">Digital</span>
                  </h6>
                </div>
                <p>
                  Como tem acontecido mesmo antes e durante a pandemia, as arrecadações de serviços digitais têm crescido de forma consistente, consequência de um crescimento de assinantes de serviços e também maior oferta de serviços, especialmente de VOD.
                </p>
              </div>
              <div class="blockBigNumbers">
                <div>
                  <h6>Crescimento de</h6>
                  <h5 class="ubcGreen sanukBlack">39,8%</h5>
                  <h6>
                  em <span class="sanukBold">Cinema</span>
                  </h6>
                </div>
                <p>
                  Apesar de não representar uma fatia grande da arrecadação, o crescimento significativo da rubrica Cinema é um alento e indicador de uma bem vinda recuperação dessa rubrica.
                </p>
              </div>
            </div>
            <div class="col49sub">
              <div class="blockBigNumbers">
                <div>
                  <h6>Crescimento de</h6>
                  <h5 class="ubcGreen sanukBlack">20,8%</h5>
                  <h6>
                  em <span class="sanukBold">Shows</span>
                  </h6>
                </div>
                <p>
                  Um dos principais fatores de recuperação pós-pandemica continua sendo um motor de crescimento da arrecadação de execução pública, ainda impulsionado pelos grandes festivais e turnês internacionais em solo brasileiro.
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
import PieChart1 from "./Grafico1.vue";
import LineChart1A from "./Grafico2.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "ArrecadacaoPage",
  props: ["clicked"],
  components: {
    PieChart1,
    LineChart1A,
    SwipperMobile
  },
  data() {
    return {
      setaScrollState: false,
      isView: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#arrecadacao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);

    setTimeout(() => {
      this.isView = true;
    }, 1500);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blockBigNumbers {
  margin: 0 0 45px 0;
}
.blockBigNumbers div {
  margin: 0 0 8px 0;
}
.canvasGraphicArea {
  width: 100%;
  background: #cecece;
}

.graphContainer {
  padding-top: 20px;
  width: 100%;
  /* background-color: #168ECD; */
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar
{
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb
{
  background-color: #8BC53F;
  border-radius: 10px;
  border: 5px solid white;
}

.graph {
  min-width: 500px;
  min-height: 250px;
}
</style>
